export default __webpack_public_path__ + "./fonts/documentacion.74844277.svg";